<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav :title="$t('我的LP')" :showLang="true"></home-nav>
		</template>
		<template v-slot:content>
			<div class="px-30 pt-20 pb-140">
                <!-- 列表为空时显示暂无数据 -->
                <div v-if="!list || list.length === 0" class="rounded-20 p-30 bg-white/10 mb-30 flex items-center justify-center">
                    <span class="text-28 text-#999">{{$t('我的LP.暂无数据')}}</span>
                </div>
				<div v-for="(item,index) in list" :key="index" class="rounded-20 p-30 bg-white/10 mb-30">
					<div class="flex items-center">
						<img class="w-88 h-88" src="@/assets/images/pages/my-lp/ldc.png" alt="" />
						<div class="ml-20 flex-1">
							<div class="flex items-center justify-between">
								<span class="text-28 text-white font-bold">LP：{{item.lp_token}}</span>
<!--								<span class="text-28 text-white font-bold">{{$t("我的LP.添加流动性")}}</span>-->
								<div v-if="item.status == 0" class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
									style="border-color:#46FF72; background-color: #46FF7220;">
									<span class="text-20" style="color: #46FF72;">{{$t("我的LP.进行中")}}</span>
								</div>
								<div v-else-if="item.status == 1" class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid" style="border-color: rgb(229 209 36); background-color: #4699FF20;">
									<span class="text-20" style="color: rgb(229 209 36);">移除中</span>
								</div>
								<div v-else-if="item.status == 2" class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
									style="border-color:#7E7E7E; background-color: #7E7E7E20;">
									<span class="text-20 text-white">{{$t("我的LP.已移除")}}</span>
								</div>
                                <div v-else-if="item.status == 3" class="px-20 h-42 rounded-12 flex items-center justify-center border border-solid"
                                     style="border-color:#4699FF; background-color: #4699FF20;">
                                    <span class="text-20" style="color: #4699FF;">已复投</span>
                                </div>
							</div>
						<div class="mt-10 flex items-center justify-between">
							<span class="text-24 text-#999">{{item.start_date}}</span>
							<span class="text-24 text-#999">ID：{{item.id}}</span>
						</div>
						</div>
					</div>
					<div class="mt-20 bg-white/10 rounded-20 p-40">
						<div class="flex items-center pb-30  border-b border-b-solid" style="border-bottom-color: #454545;">
							<div class="flex-1">
								<div>
									<span class="text-#999 text-20">USDR</span>
								</div>
								<div class="mt-20">
									<span class="text-#999 text-36 font-bold" style="color: #9646FF;">{{item.token_amount}}</span>
								</div>
							</div>
							<div class="flex-1">
								<div>
									<span class="text-#999 text-20">ROON</span>
								</div>
								<div class="mt-20">
									<span class="text-primary text-36 font-bold">{{item.roon_amount}}</span>
								</div>
							</div>
						</div>
						<div class="mt-20 flex items-center justify-between">
							<span class="text-26 text-white">起始价格：</span>
							<span class="text-26 text-primary font-bold">{{item.start_price}}</span>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-between">
						<span class="text-24 text-#999">收益：{{item.static}}</span>
						<span class="text-24 text-primary" v-if="item.status == 0 && item.surplus_day > 0">{{$t("我的LP.剩余")}}{{item.surplus_day}}{{$t("我的LP.天")}}</span>
					</div>
					<div v-if="item.status == 0 && item.surplus_day > 0" class="mt-30 rounded-full flex items-center justify-center bg-white/10 h-100">
						<span class="text-32 text-white" >{{$t("我的LP.锁定中")}}({{$t("我的LP.剩余")}}{{item.surplus_day}}{{$t("我的LP.天")}})</span>
					</div>
                    <div v-if="item.status == 0 && item.surplus_day <= 0" @click="showAgain(item)"  class="mt-30 rounded-full flex items-center justify-center bg-primary h-100">
                        <span class="text-32 text-white" >{{$t('我的LP.复投')}}</span>
                    </div>
                    <div v-if="item.status == 0 && item.surplus_day <= 0" @click="showYichu(item)" class="mt-30 rounded-full flex items-center justify-center bg-white/10 h-100">
                        <span class="text-32 text-white" >{{$t("我的LP.移除LP")}}</span>
                    </div>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<!-- <menu-bar activeMenu="node"></menu-bar> -->
		</template>
		<template v-slot:popup>
			<van-popup v-model="showAmountPopup" position="center" round>
				<div class="w-690">
					<div class="flex items-center justify-center relative h-200">
						<img class="absolute w-200 h-200" style="z-index: 100;" src="@/assets/images/common/success.png"
							alt="" />
					</div>
					<div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30" style="margin-top: -98rem;">
						<div class="flex items-center justify-center mt-20">
							<span class="text-36 text-white">{{$t("我的LP.确认移除LP")}}</span>
						</div>
						<div class="flex items-center justify-center mt-20">
							<span class="text-26 text-#999">{{$t("我的LP.您即将移除LP并获得以下资产")}}</span>
						</div>
						<div class="rounded-18 bg-#1B1B1B  mt-20 mx-20 p-30">
							<div class="flex items-center justify-between">
								<span class="text-24 text-white">{{$t("我的LP.本金返还")}}</span>
								<span class="text-24 text-white">{{showItem.principal}} USDR</span>
							</div>
<!--							<div class="mt-30 flex items-center justify-between pb-20 border-b border-b-solid" style="border-bottom-color: #454545;">-->
<!--								<span class="text-24 text-white">{{$t("我的LP.收益")}}</span>-->
<!--								<span class="text-24 text-primary">{{showItem.static}} ROON</span>-->
<!--							</div>-->
							<div class="mt-20 flex items-center justify-between">
								<span class="text-24 text-white">{{$t("我的LP.总计")}}</span>
								<span class="text-24 text-success">{{showItem.principal}} USDR</span>
<!--								<span class="text-24 text-success">{{showItem.principal}} USDR + {{showItem.static}} ROON</span>-->
							</div>
						</div>
						<div class="mt-40 flex items-center justify-center">
							<div @click="showAmountPopup = false"
								class="w-270 h-100 bg-white/10 rounded-full flex items-center justify-center mr-10">
								<span class="text-32 text-white">{{$t('弹窗.取消')}}</span>
							</div>
							<div @click="removeLiquidity"
								class="w-270 h-100 bg-primary rounded-full flex items-center justify-center ml-10">
								<span class="text-32 text-white">{{$t('我的LP.确认移除')}}</span>
							</div>
						</div>
					</div>
				</div>
			</van-popup>


            <van-popup v-model="againPopup" position="center" round>
                <div class="w-690">
                    <div class="flex items-center justify-center relative h-200">
                        <img class="absolute w-200 h-200" style="z-index: 100;" src="@/assets/images/common/success.png" alt="" />
                    </div>
                    <div class="bg-#0F0F17 rounded-20 w-690 relative pt-100 pb-30" style="margin-top: -98rem;">
                        <div class="flex items-center justify-center mt-20">
                            <span class="text-36 text-white">确定复投 LP</span>
                        </div>

                        <div class="mt-40 flex items-center justify-center">
                            <div @click="againPopup = false"
                                 class="w-270 h-100 bg-white/10 rounded-full flex items-center justify-center mr-10">
                                <span class="text-32 text-white">{{$t('弹窗.取消')}}</span>
                            </div>
                            <div @click="again"
                                 class="w-270 h-100 bg-primary rounded-full flex items-center justify-center ml-10">
                                <span class="text-32 text-white">确定复投</span>
                            </div>
                        </div>
                    </div>
                </div>
            </van-popup>
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBar from '@/components/menu-bar/menu-bar.vue';
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";
    import LiquidityManagementAbi from "@/abi/LiquidityManagementAbi"
	import PledgeAbi from "@/abi/PledgeAbi"
	import erc20Abi from "@/abi/erc20Abi"
	import Mining_Abi from "@/abi/MiningAbi";
	import {
		getShowAddress,
		setShowAddress
	} from "@/libs/util";
	import Web3 from "web3";
	export default {
		components: {
			homeNav,
			menuBar,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				typeList: [],
				queryInfo: {
					page: 1,
					type: 1
				},
				min_number: 0,
				node_allocate: 0,
				node_release: 0,
				node_low_pool: 1995,
				node_day: 0,
				node_number: 0,
				node_has: 0,
				node_price: 0,
				node_progress: 0,
				node_surplus_number: 0,
				last_pledge_id: 0,
				last_pledge_time: "",
				all_surplus_roon: "",
				roon_number: "100000",
				node_name: "",
				rgt_swap: "",
				mining_contract: "",
				last_pledge_usdt: "",
				last_pledge_name: "",
				address: "",
				total_address: "",
				show_address: "",
				order_id: "",
				users_id: "",
                usdr_address: "0xbC75b416D9b4045BBF31d3F9DA7eD727aFCa2f79",
                lp_address: "0xFC5Ee21f8afe9Ce7Ed8be9839C62c0d733c8CDB2",
                wroon_address: "0xB142a57E25eF20De7A881ea22c10b11e47c0B1a0",
                FACTORY_ADDRESS:"0xf4516EFf9b8F046E86B64FD6956dce0928296856",
                ROUTER_ADDRESS:"0xa54d92bEd6455E43a09f6315fD050edFA9997306",
                contract_address: "0xf3708a77ea0282de751244194c304554d5a5d7ed",
                usdt_address: "0x55d398326f99059fF775485246999027B3197955",
                web3Provider: null,
                web3: null,
                // 前端可覆盖滑点（bips），默认更宽松为 500 = 5%
                slippageBipsOverride: 600,
                list: [],
                amountList: [],
                showAmountPopup: false,
                againPopup: false,
                // 支付进行中的不可关闭 loading 遮罩
                paying: false,
				canGo: true,
				form: {
					type: 1,
					amount: 0,
					dd_roon: 0,
					amount_id: 0
				},
                showItem:{
                    id:0,
                    principal:0,
                    record_id:0,
                    static:0,
                },
				// 是否购买
				isBuy: true,
				numberList: [{
						id: 1,
						num: 100
					},
					{
						id: 2,
						num: 500
					},
					{
						id: 3,
						num: 1000
					},
					{
						id: 4,
						num: 2000
					},
					{
						id: 5,
						num: 5000
					},

				]
			};
		},
		computed: {
			lang() {
				return store.state.language;
			},
			activeType() {
				let item = {};
				item = this.typeList.find(item => item.id == this.queryInfo.type) || {};
				return item;
			},
			activeAmount() {
				let item = {};
				item = this.amountList.find(item => item.id == this.form.amount_id) || {};
				return item;
			}
		},
		created() {
			let vm = this
            getShowAddress()
			vm.getList();
		},
		methods: {
            async removeLiquidity(){
                const vm = this;
                if (vm.paying) return;

                try {
                    vm.paying = true;
					// 先调用后端接口，成功后再继续链上交易
					try {
						const resp = await ajaxData("/lp/remove", { id: vm.showItem.id });
						console.log("/lp/remove resp", resp);
					} catch (apiErr) {
						console.error("/lp/remove error", apiErr);
						vm.$message.error(apiErr?.message || vm.$t("吐司.操作失败"));
						vm.paying = false;
						return; // 接口异常直接结束，不继续链上操作
					}
					// 初始化 Web3
					let provider = vm.web3Provider || (window.ethereum || window.web3?.currentProvider);
					if (!provider) {
						vm.$message.error('未检测到钱包，请先连接钱包');
						vm.paying = false;
						return;
					}
                    vm.web3 = new Web3(provider);
                    // 获取地址
                    let accounts = [];
                    try {
                        accounts = await provider.request ? await provider.request({ method: 'eth_requestAccounts' }) : await vm.web3.eth.getAccounts();
                    } catch (err) {
                        accounts = await vm.web3.eth.getAccounts();
                    }
                    const fromAddress = (vm.address && vm.address.length > 0) ? vm.address : (accounts[0] || '');
                    if (!fromAddress) {
                        vm.$message.error('无法获取钱包地址');
                        vm.paying = false;
                        return;
                    }

                    // 校验当前网络是否为 ROON 主链（chainId = 1492）
                    const currentChainId = await vm.web3.eth.getChainId().catch(() => null);
                    if (currentChainId !== 1492) {
                        vm.$message.error('请切换到 ROON 主链');
                        vm.paying = false;
                        return;
                    }

					// 合约实例
					const lpContract = new vm.web3.eth.Contract(LiquidityManagementAbi, vm.lp_address);

					const recordId = vm.showItem?.record_id ?? vm.showItem?.recordId ?? vm.showItem?.id;
                    if (!recordId && recordId !== 0) {
                        vm.$message.error('缺少记录ID，无法移除');
                        vm.paying = false;
                        return;
                    }

                    // 预估 gas 并兜底 gasPrice
                    let gasPriceHex;
                    try {
                        const gp = await vm.web3.eth.getGasPrice();
                        gasPriceHex = vm.web3.utils.toHex(gp);
                    } catch {
                        gasPriceHex = vm.web3.utils.toHex(vm.web3.utils.toWei('63', 'gwei'));
                    }

                    let gasLimitHex;
                    try {
                        const gas = await lpContract.methods.removeLiquidity(recordId)
                            .estimateGas({ from: fromAddress });
                        // 加 20% 余量
                        gasLimitHex = vm.web3.utils.toHex(Math.floor(gas * 1.2));
                    } catch (estimateErr) {
                        const original = estimateErr?.data?.originalError?.message || estimateErr?.data?.message || estimateErr?.message || 'Gas 预估失败';
                        console.error('estimateGas error:', estimateErr);
                        vm.$message.error(original);
                        vm.paying = false;
                        return;
                    }

                    // 先进行一次 call 预执行，尽早拿到具体的 revert reason
                    try {
                        await lpContract.methods.removeLiquidity(recordId).call({ from: fromAddress });
                    } catch (callErr) {
                        const callMsg = callErr?.data?.originalError?.message || callErr?.data?.message || callErr?.error?.message || callErr?.message || '模拟执行失败';
                        console.error('removeLiquidity call() error:', callErr);
                        vm.$message.error(callMsg);
                        vm.paying = false;
                        return;
                    }

                    // 发送交易移除流动性
                    await lpContract.methods.removeLiquidity(recordId).send({ from: fromAddress, gas: gasLimitHex, gasPrice: gasPriceHex });
                    vm.$message.success('移除成功');
                    vm.showAmountPopup = false;
                    // 刷新列表
                    vm.getList && vm.getList();
                } catch (error) {
                    console.error('removeLiquidity error', error);
                    const msg = error?.data?.originalError?.message || error?.data?.message || error?.error?.message || error?.message || '移除失败';
                    vm.$message.error(msg);
                } finally {
                    vm.paying = false;
                }
            },
            showYichu(item){
                let vm = this
                vm.showItem = item
                vm.showAmountPopup = true
            },
            showAgain(item){
                let vm = this
                vm.showItem = item
                vm.againPopup = true
            },
			goToLock() {
				this.$router.push({
					path: '/lock'
				})
			},
            again() {
                let vm = this
                ajaxData("/lp/again",{
                    id:vm.showItem.id
                }).then(res => {
                    console.log(res)
                    vm.$message.success("操作成功")
                    vm.getList()
                    vm.againPopup = false
                })
            },
			getList() {
				let vm = this
				ajaxData("/lp/record").then(res => {
					console.log(res)
					vm.list = res.data.list;
				})
			},
			async getUserNodePurchaseStatus() {
				const vm = this;
				const contract = new vm.web3.eth.Contract(Mining_Abi, vm.mining_contract);
				let data = await contract.methods.getUserNodePurchaseStatus(vm.address).call();
				console.log(data)
				console.log(data.nodeCount)
			},
			handleInputTwo() {
				const vm = this;
				let val = String(vm.form?.amount ?? '');
				// 仅保留数字（不允许小数点与其他字符）
				val = val.replace(/\D/g, '');
				// 解析后的数值可能出现 NaN 的情况，需回退
				const parsed = parseInt(val, 10);
				if (!val.length || Number.isNaN(parsed) || !Number.isFinite(parsed)) {
					vm.form.amount = '';
					vm.form.dd_roon = 0;
					return;
				}
				vm.form.amount = parsed;
				vm.form.dd_roon = parsed / 20;
			},
			setQueryInfo(type) {
				this.queryInfo.type = type;
				this.form.type = type;
			},
			selectAmount(number) {
				this.form.amount = parseInt(number);
				this.form.dd_roon = this.form.amount / 20;

				// this.form.amount_id = item.id;
				// this.showAmountPopup = false;
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	.swap-item1-bg-image {
		width: 690rem;
		height: 240rem;
		background-image: url("~@/assets/images/pages/swap/img_banner.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.swap-item2-bg-image {
		width: 326rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/swap/item1Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.swap-item3-bg-image {
		width: 326rem;
		height: 242rem;
		background-image: url("~@/assets/images/pages/swap/item2Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.bg-\#5ACC3C {
		background-color: #5ACC3C;
	}
</style>




